module.exports = __webpack_public_path__ + "static/media/virat@3x.79ef764b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/website-bot/img/virat@3x.webp
// module id = 439
// module chunks = 0